import { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import "./page.css";
import logo from "../Views/Admin/IMG/Logo.png";
import GetNotificationAdmin from "../Services/Admin/GetNotificationAdmin";
import { NotificationState } from "./NewSidebarMagasin";

const SIDEBAR_KEY = "admin_sidebar_collapsed";

const DashboardIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <rect x="3" y="3" width="7" height="7" rx="1" />
    <rect x="14" y="3" width="7" height="7" rx="1" />
    <rect x="3" y="14" width="7" height="7" rx="1" />
    <rect x="14" y="14" width="7" height="7" rx="1" />
  </svg>
);
const Transaction = () => (
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-credit-card" viewBox="0 0 16 16">
  <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v1h14V4a1 1 0 0 0-1-1zm13 4H1v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1z"/>
  <path d="M2 10a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1z"/>
</svg>
);
const DeplacementIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-geo-alt-fill" viewBox="0 0 16 16">
  <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10m0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6"/>
</svg>
);

const LogoutIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
    <polyline points="16 17 21 12 16 7" />
    <line x1="21" y1="12" x2="9" y2="12" />
  </svg>
);

const SettingsIcon = () => (
  <i style={{ color: "white" }} className="bi bi-gear-fill"></i>
);

const ReportsIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-boxes" viewBox="0 0 16 16">
    <path d="M7.752.066a.5.5 0 0 1 .496 0l3.75 2.143a.5.5 0 0 1 .252.434v3.995l3.498 2A.5.5 0 0 1 16 9.07v4.286a.5.5 0 0 1-.252.434l-3.75 2.143a.5.5 0 0 1-.496 0l-3.502-2-3.502 2.001a.5.5 0 0 1-.496 0l-3.75-2.143A.5.5 0 0 1 0 13.357V9.071a.5.5 0 0 1 .252-.434L3.75 6.638V2.643a.5.5 0 0 1 .252-.434zM4.25 7.504 1.508 9.071l2.742 1.567 2.742-1.567zM7.5 9.933l-2.75 1.571v3.134l2.75-1.571zm1 3.134 2.75 1.571v-3.134L8.5 9.933zm.508-3.996 2.742 1.567 2.742-1.567-2.742-1.567zm2.242-2.433V3.504L8.5 5.076V8.21zM7.5 8.21V5.076L4.75 3.504v3.134zM5.258 2.643 8 4.21l2.742-1.567L8 1.076zM15 9.933l-2.75 1.571v3.134L15 13.067zM3.75 14.638v-3.134L1 9.933v3.134z" />
  </svg>
);

const MessengerIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-shop-window" viewBox="0 0 16 16">
    <path d="M2.97 1.35A1 1 0 0 1 3.73 1h8.54a1 1 0 0 1 .76.35l2.609 3.044A1.5 1.5 0 0 1 16 5.37v.255a2.375 2.375 0 0 1-4.25 1.458A2.37 2.37 0 0 1 9.875 8 2.37 2.37 0 0 1 8 7.083 2.37 2.37 0 0 1 6.125 8a2.37 2.37 0 0 1-1.875-.917A2.375 2.375 0 0 1 0 5.625V5.37a1.5 1.5 0 0 1 .361-.976zm1.78 4.275a1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0 1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0 1.375 1.375 0 1 0 2.75 0V5.37a.5.5 0 0 0-.12-.325L12.27 2H3.73L1.12 5.045A.5.5 0 0 0 1 5.37v.255a1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0M1.5 8.5A.5.5 0 0 1 2 9v6h12V9a.5.5 0 0 1 1 0v6h.5a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1H1V9a.5.5 0 0 1 .5-.5m2 .5a.5.5 0 0 1 .5.5V13h8V9.5a.5.5 0 0 1 1 0V13a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9.5a.5.5 0 0 1 .5-.5" />
  </svg>
);

const DemandeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-send-fill" viewBox="0 0 16 16">
    <path d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 3.178 4.995.002.002.26.41a.5.5 0 0 0 .886-.083zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471z" />
  </svg>
);

const CommisionIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-link-45deg" viewBox="0 0 16 16">
    <path d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1 1 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4 4 0 0 1-.128-1.287z" />
    <path d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243z" />
  </svg>
);

const ExpeditionIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
    <path d="M0 3.5A1.5 1.5 0 0 1 1.5 2h9A1.5 1.5 0 0 1 12 3.5V5h1.02a1.5 1.5 0 0 1 1.17.563l1.481 1.85a1.5 1.5 0 0 1 .329.938V10.5a1.5 1.5 0 0 1-1.5 1.5H14a2 2 0 1 1-4 0H5a2 2 0 1 1-3.998-.085A1.5 1.5 0 0 1 0 10.5zm1.294 7.456A2 2 0 0 1 4.732 11h5.536a2 2 0 0 1 .732-.732V3.5a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .294.456M12 10a2 2 0 0 1 1.732 1h.768a.5.5 0 0 0 .5-.5V8.35a.5.5 0 0 0-.11-.312l-1.48-1.85A.5.5 0 0 0 13.02 6H12zm-9 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2m9 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2"/>
  </svg>
);

const UtilisateursIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-people-fill" viewBox="0 0 16 16">
    <path d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6m-5.784 6A2.24 2.24 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.3 6.3 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1zM4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" />
  </svg>
);

const EnCompteIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
    <rect x="2" y="5" width="20" height="14" rx="2" />
    <line x1="2" y1="10" x2="22" y2="10" />
    <line x1="6" y1="15" x2="10" y2="15" />
  </svg>
);

const menuItems = [
  { path: "/home", label: "Accueil", icon: DashboardIcon },
  { path: "/magasin", label: "Magasins", icon: MessengerIcon },
  { path: "/deplacement", label: "Deplacement", icon: DeplacementIcon },
  { path: "/admin/en-compte", label: "En Compte", icon: EnCompteIcon },
  { path: "/historiques", label: "Suivi", icon: ReportsIcon },
  { path: "/utilisateurs", label: "Utilisateurs", icon: UtilisateursIcon },
  // { path: "/commission", label: "Commission", icon: CommisionIcon },
  
  { path: "/transaction", label: "Transaction", icon: Transaction },
  { path: "/expedition", label: "Expédition", icon: ExpeditionIcon },
];

export const NewSideBarAdmin = () => {
  const [stateNotification, setStateNotification] = useState<NotificationState>({
    Notifications: [],
    messageErrosNotif: "Aucune Notification",
  });

  // Desktop: persisted in localStorage
  const [isCollapsed, setIsCollapsed] = useState<boolean>(() => {
    return localStorage.getItem(SIDEBAR_KEY) === "true";
  });

  // Mobile: completely separate — starts closed, never reads localStorage
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  const [screenWidth, setScreenWidth] = useState<number>(window.innerWidth);
  const location = useLocation();

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Auto-close mobile drawer on every route change
  useEffect(() => {
    setIsMobileOpen(false);
  }, [location.pathname]);

  const isMobile = screenWidth <= 768;

  useEffect(() => {
    const offset = isMobile ? "0px" : isCollapsed ? "80px" : "200px";
    document.body.classList.add("app-has-sidebar");
    document.documentElement.style.setProperty("--app-sidebar-offset", offset);

    return () => {
      document.body.classList.remove("app-has-sidebar");
      document.documentElement.style.removeProperty("--app-sidebar-offset");
    };
  }, [isMobile, isCollapsed]);

  // Desktop toggle only — saves to localStorage
  const toggleSidebar = () => {
    setIsCollapsed((prev) => {
      const next = !prev;
      localStorage.setItem(SIDEBAR_KEY, String(next));
      return next;
    });
  };

  // Mobile toggle only — fully independent
  const toggleMobileSidebar = () => setIsMobileOpen((prev) => !prev);
  const closeMobileSidebar = () => setIsMobileOpen(false);

  useEffect(() => {
    GetNotificationAdmin()
      .GetNotification()
      .then((res) => {
        const unread = res.data.filter((notif: any) => notif.IsRead === 0);
        setStateNotification((prev) => ({ ...prev, Notifications: unread }));
      })
      .catch(() => {
        setStateNotification((prev) => ({
          ...prev,
          messageErrosNotif: "Aucune Notification",
        }));
      });
  }, []);

  // collapsed-new only applies on desktop
  // open-mobile-new only applies on mobile
  const asideClass = [
    "sidebar-new",
    !isMobile && isCollapsed ? "collapsed-new" : "",
    isMobile && isMobileOpen ? "open-mobile-new" : "",
  ]
    .filter(Boolean)
    .join(" ");

  // Whether to show text labels
  const showLabels = isMobile || !isCollapsed;

  return (
    <>
      {/* Hamburger — mobile only */}
      {isMobile && (
        <button className="mobile-menu-trigger-nsb" onClick={toggleMobileSidebar}>
          <i className="bi bi-list" />
        </button>
      )}

      {/* Dark overlay — mobile only */}
      {isMobile && (
        <div
          className={`sidebar-overlay-nsb ${isMobileOpen ? "active-nsb" : ""}`}
          onClick={closeMobileSidebar}
        />
      )}

      <section>
        {/* Notification Button */}
        <div className="notification-btn-wrapper">
          <NavLink to="/notification">
            <button className="notification-btn radiate">
              <i className="bi bi-bell"></i>
              {stateNotification.Notifications.length > 0 && (
                <span className="notif-badge">
                  {stateNotification.Notifications.length}
                </span>
              )}
            </button>
          </NavLink>
        </div>

        <aside className={asideClass}>
          {/* Toggle chevron button — desktop only */}
          {!isMobile && (
            <button className="toggle-sidebar-btn" onClick={toggleSidebar}>
              <i className={`bi ${isCollapsed ? "bi-chevron-right" : "bi-chevron-left"}`} />
            </button>
          )}

          <div className="sidebar-content-new">
            {/* User Profile */}
            <div className="user-profile-new">
              <div className="user-avatar-new">
                <img src={logo} alt="Logo" />
              </div>
              {showLabels && (
                <div className="user-info-new">
                  <h3>Logo</h3>
                </div>
              )}
            </div>

            {/* Navigation */}
            <nav className="sidebar-nav-new">
              {menuItems.map((item) => (
                <NavLink
                  key={item.path}
                  to={item.path}
                  className={({ isActive }) =>
                    `nav-item-new ${isActive ? "active-new" : ""}`
                  }
                  title={!showLabels ? item.label : ""}
                  onClick={() => isMobile && closeMobileSidebar()}
                >
                  <item.icon />
                  {showLabels && <span>{item.label}</span>}
                </NavLink>
              ))}
            </nav>

            {/* Bottom Section */}
            <div className="sidebar-bottom-new">
              <div className="bottom-actions-new">
                <button className="action-btn-new" title={!showLabels ? "Settings" : ""}>
                  <NavLink to="/paramétres" onClick={() => isMobile && closeMobileSidebar()}>
                    <SettingsIcon />
                    {showLabels && <span>Paramètre</span>}
                  </NavLink>
                </button>
                <NavLink to="/logout" onClick={() => isMobile && closeMobileSidebar()} className="logout-pro-btn">
                  <LogoutIcon />
                  {showLabels && <span>Déconnecter</span>}
                </NavLink>
              </div>
            </div>
          </div>
        </aside>

        {/* Floating Bottom-Right */}
        <div className="floating-icons-new" style={{ display: "flex", flexDirection: "column", gap: 10, position: "fixed", bottom: 20, right: 20, zIndex: 9999 }}>
          <NavLink to="/admin/reclamations">
            <div className="tooltip-container">
              <button className="floating-btn ticket-btn" style={{ background: "linear-gradient(135deg, #ffc400, #ff9100)", color: "#111" }}>
                <i className="bi bi-shield-exclamation"></i>
              </button>
              <span className="tooltip-text">Réclamations</span>
            </div>
          </NavLink>
          <NavLink to="/ticket">
            <div className="tooltip-container">
              <button className="floating-btn ticket-btn">
                <i className="bi bi-ticket-perforated-fill"></i>
              </button>
              <span className="tooltip-text">Ticket</span>
            </div>
          </NavLink>
        </div>
      </section>
    </>
  );
};